
<template>
  <div class="wallet">
    <div class="item" v-for="item in list" :key="item.student.id" @click="goDetail(item)">
      <div class="flex-center">
        <div class="student-name">{{ item.student.name ? item.student.name.substr(-2) : '' }}</div>
        {{ item.student.name }}
      </div>
      <div class="right flex-center">
        ¥{{ item.totalMoney | formatNumber }}
        <van-icon name="arrow" size="16" color="var(--g5)"/>
      </div>
    </div>
    <!-- <empty-page :show="!list.length" tips="暂无电子钱包"></empty-page> -->
  </div>
</template>

<script>
// import emptyPage from '@parent/components/empty-page.vue';
export default {
  name: 'wallet',
  // components: {
  //   emptyPage,
  // },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    goDetail(item){
      this.$router.push({
        name: 'wallet-record',
        params: {
          id: item.student.id,
          money:item.totalMoney,
        }
      })
    },
  },
  async created() {
    const res = await this.$api.findStudentWallet();
    this.list = res.data;
  },
};
</script>

<style lang="scss" scoped>
.wallet {
  background: var(--white);
  .item {
    padding: 18px 16px;
    background: #f7f8fa;
    border-radius: 12px;
    margin: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    color: var(--g8);
    .flex-center {
      .student-name {
        flex-shrink: 0;
        margin-right: calc(var(--gap) * 8);
        width: calc(var(--w) * 40);
        height: calc(var(--w) * 40);
        line-height: calc(var(--w) * 40);
        border-radius: 50%;
        background-color: var(--c1);
        color: var(--white);
        text-align: center;
      }
    }
    .right {
      color: #1890FF;
    }
  }
}
</style>